<template>
  <div class="date-range-picker">
    <button class="btn btn-primary" @click="toggleDateRangePicker">
      {{ dateRangeLabel }} <i class="fa fa-chevron-down"></i>
    </button>

    <div v-if="isPickerVisible" class="date-picker-popup">
      <div class="date-picker-content">
        <!-- 永遠顯示日期選擇器（無預設範圍） -->
        <div class="custom-range-picker">
          <Datepicker v-model="customDateRange" inline range :auto-apply="true" />
          <div class="actions">
            <button class="btn btn-primary" @click="cancelCustomRange">Cancel</button>
            <button class="btn btn-primary" @click="applyCustomRange">OK</button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup>
import { ref } from 'vue';
import Datepicker from '@vuepic/vue-datepicker';
import '@vuepic/vue-datepicker/dist/main.css';
import { useReportStore } from '@/store/driver/report';

const reportStore = useReportStore();

// 控制下拉顯示
const isPickerVisible = ref(false);

// 預設按鈕名稱
const dateRangeLabel = ref('Select Date Range');

// 記錄自訂義日期
const customDateRange = ref([new Date(), new Date()]);

// 切換顯示/隱藏
const toggleDateRangePicker = () => {
  isPickerVisible.value = !isPickerVisible.value;
};

// 按下 OK 時
const applyCustomRange = async () => {
  if (customDateRange.value.length === 2) {
    const [start, end] = customDateRange.value;

    // 更新按鈕文字
    dateRangeLabel.value = `${formatDate(start)} - ${formatDate(end)}`;

    // 呼叫 API
    await reportStore.fetchReportInfo('custom', formatDateISO(start), formatDateISO(end));

    isPickerVisible.value = false;
  }
};

// 按下 Cancel 時
const cancelCustomRange = () => {
  // 不修改任何資料, 直接關閉
  isPickerVisible.value = false;
};

// 自訂格式：日/英文簡寫月/兩位數年 (例如 5/Jun/25)
const formatDate = (date) => {
  const day = date.getDate();
  const monthShort = date.toLocaleString('en-US', { month: 'short' }); // Jun, Jul...
  // 從年份只取後兩位
  const yearShort = String(date.getFullYear()).slice(-2);
  return `${day}/${monthShort}/${yearShort}`;
};

// 為了呼叫 API 要用 ISO date
const formatDateISO = (date) => {
  return date.toISOString().split('T')[0];
};
</script>

<style scoped>
.btn-primary {
  border-radius: 30px;
  font-size: 16px;
}

.date-range-picker {
  position: relative;
}

.date-picker-popup {
  position: absolute;
  margin-top: 10px;
  top: -30px;
  left: -20px;
  background: white;
  padding: 20px;
  z-index: 1050;
  min-width: 320px;
  min-height: 280px;
}

.date-picker-content {
  display: flex;
  flex-direction: column;
}

.custom-range-picker {
  position: relative;
}

.actions {
  display: flex;
  justify-content: flex-end;
  margin-top: 20px;
}

.actions .btn {
  margin-left: 10px;
}
</style>
